export class TaxAdvisorManager {
  id?: string;
  name: string;
  email: string;
  phone_number: string;
  password: string;
  password_confirmation?: string;
  is_active?: boolean;
}
